<template>
        <div class="grid-container">
            <div class="grid-x">
                <p>&nbsp;</p>
                <div class="table__wrapper cell" v-if="studies">
                    <table class="table table--saved-studies">
                        <caption><h2>{{labels.savedStudies}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.titleOfStudy}}</th>
                                <th>{{labels.author}}</th>
                                <th>{{labels.yearOfPublication}}</th>
                                <th>{{labels.notes}}</th>
                                <th>{{labels.dateSaved}}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="studies.length > 0">
                            <tr v-for="(study, k) of studies"
                                :key="k"
                                :title="study.studyTitle">
                                <td @click="openStudy(study.studyId)" @keyup.enter="openStudy(study.studyId)" tabindex="0">{{trimmedTitle(study.title)}}</td>
                                <td>{{study.author}}</td>
                                <td>{{ study.publicationYear | formatDate }}</td>
                                <td>
                                    <popup-info-box :text="study.description"
                                                    :infoIconReplaceText="labels.viewNote">
                                    </popup-info-box>
                                </td>
                                <td>{{ study.saveDate | formatDate }}</td>
                                <td><a @click.stop="deleteStudy(study)" @keyup.enter="deleteStudy(study)" class="text--red" tabindex="0">{{labels.delete}}</a></td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6" class="table__nothing">{{labels.youHaveNoSavedStudies}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="cell" v-else>
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingSavedStudies}}</div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>

                <div class="table__wrapper cell" v-if="jobeffects">
                    <table class="table table--library">
                        <caption><h2>{{labels.savedResults}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.resultName}}</th>
                                <th>{{labels.notes}}</th>
                                <th>{{labels.dateSaved}}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="jobeffects.length > 0">
                            <tr v-for="(jobeffect, k) of jobeffects" :key="k">
                                <td @click="showJobeffect(jobeffect)" @keyup.enter="showJobeffect(jobeffect)" tabindex="0">{{jobeffect.name}}</td>
                                <td>
                                    <popup-info-box 
                                        :text="jobeffect.description"
                                        :infoIconReplaceText="labels.viewNote">   
                                    </popup-info-box>
                                </td>
                                <td>{{ jobeffect.saveDate | formatDate }}</td>
                                <td>
                                    <a @click.stop="deleteResult(jobeffect)" @keyup.enter="deleteResult(jobeffect)" tabindex="0" class="text--red">{{labels.delete}}</a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6" class="table__nothing">{{labels.youHaveNoSavedResults}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="cell" v-else>
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingSavedStudies}}</div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>

                <div class="table__wrapper cell" v-if="criterias">
                    <table class="table table--library">
                        <caption><h2>{{labels.savedSearchCriteria}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.searchCriteriaName}}</th>
                                <th>{{labels.notes}}</th>
                                <th>{{labels.dateSaved}}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="criterias.length > 0">
                            <tr v-for="(criteria, k) of criterias" :key="k">
                                <td @click="showCriteria(criteria)" @keyup.enter="showCriteria(criteria)" tabindex="0">{{criteria.name}}</td>
                                <td>
                                     <popup-info-box 
                                        :text="criteria.description"
                                        :infoIconReplaceText="labels.viewNote">   
                                    </popup-info-box>
                                </td>
                                <td>{{ criteria.saveDate | formatDate }}</td>
                                <td>
                                    <a @click.stop="deleteCriteria(criteria)" @keyup.enter="deleteCriteria(criteria)" tabindex="0" class="text--red">{{labels.delete}}</a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6" class="table__nothing">{{labels.youHaveNoSavedSearchCriteria}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="cell" v-else>
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingSavedSearchCriteria}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Study agent temporarily commented out -->
            <!-- <div class="grid-x grid-padding-x">
                <div class="cell text-center">
                    <p>&nbsp;</p>
                    <h1>{{labels.studyAgent}}</h1>
                    <p class="lead">{{labels.receiveNotification}}</p>
                    <p>&nbsp;</p>
                </div>
                <div class="cell large-6">
                    <div class="table__wrapper">
                        <table class="table table--agent" v-if="agents && agents.searchActivities">
                            <caption>{{labels.selectInterventions}}</caption>
                            <thead>
                                <tr>
                                    <th>{{labels.intervention}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(agent, k) of agents.searchActivities">
                                    <tr :key="k">
                                        <td @click="agent.open = !agent.open">
                                            <span v-if="agent.open" class="table__minus"></span>
                                            <span v-else class="table__plus"></span>
                                            {{agent.option.name}}
                                        </td>
                                        <td><input type="checkbox" @change="agentState='dirty'" v-model="agent.option.selected" /></td>
                                    </tr>
                                    <tr v-for="(childAgent, l) of agent.childOptions" :key="l" v-if="agent.open" class="table__agent-input">
                                        <td><label :for="childAgent.id">{{childAgent.name}}</label></td>
                                        <td><input type="checkbox" @change="agentState='dirty'" :id="childAgent.id" v-model="childAgent.selected" /></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="cell large-6">
                    
                    <div class="table__wrapper">
                        <table class="table table--agent" v-if="agents && agents.searchTargetGroups">
                            <caption>{{labels.selectTargetGroups}}</caption>
                            <thead>
                                <tr>
                                    <th>{{labels.targetGroup}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(targetgroup, k) of agents.searchTargetGroups">
                                    <tr :key="k">
                                        <td @click="targetgroup.open = !targetgroup.open">
                                            <span v-if="targetgroup.open" class="table__minus"></span>
                                            <span v-else class="table__plus"></span>
                                            {{targetgroup.option.name}}
                                        </td>
                                        <td><input type="checkbox" @change="agentState='dirty'" v-model="targetgroup.option.selected" /></td>
                                    </tr>
                                    <tr v-for="(childTargetgroup, l) of targetgroup.childOptions" :key="l" v-if="targetgroup.open" class="table__agent-input">
                                        <td><label :for="childTargetgroup.id">{{childTargetgroup.name}}</label></td>
                                        <td><input type="checkbox" @change="agentState='dirty'" :id="childTargetgroup.id" v-model="childTargetgroup.selected" /></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>  
                </div>
                <div class="cell" v-if="!agents">
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingStudyAgent}}</div>
                        </div>
                    </div>
                </div>
                <div class="cell buttons" v-else>
                    <div class="buttons__group stacked-for-small">
                        <a class="button secondary" v-if="agentState === 'dirty'" @click="reinit()">{{labels.undoSelection}}</a>
                        <button :disabled="agentState !== 'dirty'" class="button" @click="save()">{{labels.updateStudyAgent}}</button>
                        <span class="button__label" v-if="agentState==='saved'">{{labels.theStudyAgentWasUpdated}}</span>
                    </div>
                </div>
            </div>-->
        </div>
</template>


<script>
import { each } from 'lodash'
import PopupInfoBox from '../PopupInfoBox.vue';
export default {
    name: 'myLibrary',
    components: { PopupInfoBox },
    data() {
        return {
            agentState: 'pristine',
            pop: ''
        }
    },
    computed: {
        studies() {
            return this.$store.state.savedStudies;
        },
        jobeffects() {
            return this.$store.state.savedJobeffectResults;
        },
        criterias() {
            return this.$store.state.savedSearchCriterias;
        },
        agents() {
            return this.$store.state.savedAgent;
        },
        labels() {
            return this.$store.state.labels['pages.mypage.mylibrary'] || { };
        }
    },
    methods: {
        reinit() {
            this.$store.dispatch('getSavedAgent');
            this.agentState = 'pristine';
        },
        save() {
            this.$store.dispatch('updateSavedAgent', this.agents).then(() => {
                this.agentState = 'saved';
            })
        },
        showJobeffect(jobeffect) {
            window.location.href = window.vm.paths.jobeffectDetails + addParam(jobeffect.searchParameters, "?");
        },
        showCriteria(criteria) {
            var paramString = "?id=" + criteria.jobeffectsSearchCriterias.selectedIds.join('&id=') + "&positiveOnly=" + criteria.jobeffectsSearchCriterias.positiveOnly;
            window.location.href = window.vm.paths.jobeffectSearch + paramString;
        },
        deleteStudy(study) {
            this.$store.dispatch('delete', { type: 'studies', id: study.id }).then(() => {
                setTimeout(() => {
                    this.$store.dispatch('getSavedStudies');
                }, 500);
            })
        },
        openStudy(id) {
            window.location.href = window.vm.paths.studySummary + id;
        },
        deleteResult(result) {
            this.$store.dispatch('delete', { type: 'jobeffect-results', id: result.id }).then(() => {
                setTimeout(() => {
                    this.$store.dispatch('getSavedJobeffectResults');
                }, 500);
            })
        },
        deleteCriteria(criteria) {
            this.$store.dispatch('delete', { type: 'search-criterias', id: criteria.id }).then(() => {
                setTimeout(() => {
                    this.$store.dispatch('getSavedJSearchCriterias');
                }, 500);
            })
        },
        trimmedTitle(title) {
            if (title.length > 75) {
                title = title.slice(0, 65) + "...";
            }
            return title;
        }
    },
        mounted() {
        this.$store.dispatch('getLabels', { label: 'pages.mypage.mylibrary' });
        this.$store.dispatch('getSavedStudies');
        this.$store.dispatch('getSavedJobeffectResults');
        this.$store.dispatch('getSavedJSearchCriterias');
        this.$store.dispatch('getSavedAgent');
    }
}

function addParam(obj, paramString = "?"){
    each(obj, (val, key) => {
        if (paramString !== "?") paramString += '&';
        if(typeof val === 'object'){
            each(val, (val2) => paramString += '&' + key + "=" + val2);
        } else {
            paramString += key + "=" + val;
        }
    });
    return paramString;
}
</script>



// WEBPACK FOOTER //
// src/components/my-pages/MyLibrary.vue